import {Component, OnInit, Input, Output, ViewChild, EventEmitter} from '@angular/core';
import { DialogRef } from '@progress/kendo-angular-dialog';
import { AutoUnsubscribe } from '../../../fw/decoractors/AutoUnsubscribe';
import {ColumnDefinition} from "../../../fw/dynamic-grids/column-definition";
import {DynamicGridComponent} from "../../../fw/dynamic-grids/dynamic-grid.component";
import {DtoArticleDiscount} from "./models/DtoArticleDiscount";

@Component({
    selector: 'article-discount',
    template: require('./article-discount.component.html'),
    styles: [require('./article-discount.component.css')]
})
@AutoUnsubscribe()

export class ArticleDiscountComponent implements OnInit {
    @Input() dialog: DialogRef;
    @Input() allDiscounts: DtoArticleDiscount[];
    @Input() chosenDiscounts: DtoArticleDiscount[];
    @Output() discountSaved = new EventEmitter<DtoArticleDiscount>();
    @ViewChild('grid', {static: false}) grid: DynamicGridComponent;
    columnDefinition: ColumnDefinition[] = [
        {
            key: 'index',
            label: 'Nummer',
            type: 'number',
            width: '100px'
        },
        {
            key: 'description',
            label: 'Omschrijving',
            type: 'string',
            width: '*'
        },
        {
            key: 'discountAmount',
            label: 'korting',
            type: 'number',
            width: '140px'
        }
    ];

    ngOnInit() {
        let discountsToShow: DtoArticleDiscount[] = [];
        for (let i = 0; i < this.allDiscounts.length; i++) {
            if (!this.chosenDiscounts.find(x => x.id == this.allDiscounts[i].id)) {
                discountsToShow.push(this.allDiscounts[i]);
            }
        }
        this.grid.showData(discountsToShow);
    }

    btnCancelClicked(event) {
        this.closeWindow(false);
    }

    btnSaveClicked(event) {
        if (this.grid.getSelectedId() > 0) {
            this.discountSaved.emit(this.grid.getSelectedItem());
            this.closeWindow(true);
        }
    }

    rowdoubleClicked(event) {
        this.btnSaveClicked(null);
    }

    closeWindow(result: boolean) {
        if (this.dialog) {
            this.dialog.dialog.instance.action.emit(result);
            this.dialog.close();
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/settings/settings-cashreg/article-discount.component.ts